export { LandingCtaLink, type LandingCtaSection } from './landing-cta-link'
